
import { defineComponent, PropType } from "vue";

export default defineComponent({
  name: "EventList",
  props: {
    events: {
      type: Array as PropType<Events.Event[]>,
      default: () => [],
    },
  },
});
